(() => {
  const activeTickers = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initTicker(root) {
    const items = Array.from(root.querySelectorAll('[data-announcement-item]'));
    if (items.length < 2 || activeTickers.has(root)) return;
    let index = 0;
    let timer;
    let paused = reducedMotion.matches || root.dataset.rotate !== 'true';
    const pauseButton = root.querySelector('[data-announcement-pause]');
    function show(next) {
      index = (next + items.length) % items.length;
      items.forEach((item, itemIndex) => { item.hidden = itemIndex !== index; });
      const count = root.querySelector('[data-announcement-count]');
      if (count) count.textContent = `${index + 1} / ${items.length}`;
    }
    function stop() { window.clearInterval(timer); }
    function start() {
      stop();
      if (!paused && !document.hidden && !root.matches(':hover') && !root.contains(document.activeElement)) timer = window.setInterval(() => show(index + 1), 6000);
    }
    function renderPause() {
      if (!pauseButton) return;
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      const path = pauseButton.querySelector('path');
      if (path) path.setAttribute('d', paused ? 'm7 4 8 6-8 6Z' : 'M7 5v10M13 5v10');
    }
    root.querySelector('[data-announcement-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    pauseButton?.addEventListener('click', () => { paused = !paused; renderPause(); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', () => window.setTimeout(start, 0));
    const visibilityHandler = () => document.hidden ? stop() : start();
    document.addEventListener('visibilitychange', visibilityHandler);
    const motionHandler = () => { if (reducedMotion.matches) { paused = true; renderPause(); stop(); } };
    reducedMotion.addEventListener('change', motionHandler);
    activeTickers.set(root, { stop, show, destroy() { stop(); document.removeEventListener('visibilitychange', visibilityHandler); reducedMotion.removeEventListener('change', motionHandler); activeTickers.delete(root); } });
    renderPause(); start();
  }
  function initialize(scope = document) { scope.querySelectorAll('[data-birdy-announcement]').forEach(initTicker); }
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-close-shell]');
    if (close) {
      const disclosure = close.closest('details');
      if (disclosure) { disclosure.open = false; disclosure.querySelector('summary')?.focus(); }
      return;
    }
    document.querySelectorAll('.birdy-shell-disclosure[open]').forEach(disclosure => {
      if (!disclosure.contains(event.target)) disclosure.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest('.birdy-shell-disclosure[open]');
    if (disclosure) { disclosure.open = false; disclosure.querySelector('summary')?.focus(); }
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-birdy-announcement]').forEach(root => activeTickers.get(root)?.destroy());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('[data-announcement-item]');
    if (!item) return;
    const root = item.closest('[data-birdy-announcement]');
    const ticker = activeTickers.get(root);
    if (ticker) { ticker.stop(); ticker.show(Array.from(root.querySelectorAll('[data-announcement-item]')).indexOf(item)); }
  });
  initialize();
})();
